// extracted by mini-css-extract-plugin
export var active = "LinkGroup-module--active--a3c27";
export var label = "LinkGroup-module--label--f08cb";
export var link = "LinkGroup-module--link--b812f";
export var linkGroup = "LinkGroup-module--linkGroup--8a0ed";